export interface AccessoryModel {
  id?: string;
  productNumber?: string;
  productDescription?: string;
  deviceKey?: string;
  originalSolutionKey?: string;
  serialNumber?: string;
  assetId?: string;
}

export function accessoryModelFactory(json?: any): AccessoryModel {
  json = json || {};
  return {
    id: json.id || "",
    productNumber: json.productNumber || "",
    productDescription: json.productDescription || "",
    deviceKey: json.deviceKey || "",
    originalSolutionKey: json.originalSolutionKey || "",
    serialNumber: json.serialNumber || "",
    assetId: json.assetId || "",
  } as AccessoryModel;
}
